import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useLabels } from './useLabels';
import { normalizeReturnTo, resolveOriginLabelKey } from '../utils/editorReturn';

/**
 * Resolves whether the current create/edit page was reached via a
 * "crear nueva..." returnTo redirect, and if so gives back a labelled
 * navigate-back callback for a secondary button (see the New___.jsx page
 * shells under screens/). Query param is the convention; location.state is
 * checked too because EditAssetSale.jsx passes returnTo that way.
 */
export const useEditorReturn = () => {
	const navigate = useNavigate();
	const { t } = useLabels();
	const [searchParams] = useSearchParams();
	const location = useLocation();

	const raw = searchParams.get('returnTo') || location.state?.returnTo || null;
	const returnTo = normalizeReturnTo(raw);

	return {
		returnTo,
		returnLabel: returnTo ? t(resolveOriginLabelKey(returnTo)) : null,
		onReturn: returnTo ? () => navigate(returnTo) : undefined,
	};
};
